import { Field } from 'formik';
import React, { useEffect } from 'react';
import { ButtonClean, Fieldset, Input } from '@fourthwall/components';
import { OptionsDescription, OptionsSection, OptionsTitle } from './forms.styled';
export const SelectForm = ({ setFieldValue, values }) => {
    const options = values.options || [];
    // Ensure there's at least one option
    useEffect(() => {
        if (options.length === 0) {
            setFieldValue('options', [{ value: '', label: '', group: '' }]);
        }
    }, [options.length, setFieldValue]);
    const handleOptionAdd = () => {
        setFieldValue('options', [...options, { value: '', label: '', group: '' }]);
    };
    const handleOptionRemove = (optionIndex) => {
        // Don't allow removing the last option
        if (options.length <= 1)
            return;
        const newOptions = [...options];
        newOptions.splice(optionIndex, 1);
        setFieldValue('options', newOptions);
    };
    const renderOptions = () => {
        return options.map((option, index) => (React.createElement(Fieldset.Row, { key: index },
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: `options[${index}].value`, type: "text", component: Input, label: `Option ${index + 1} Value`, defaultValue: option.value })),
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: `options[${index}].label`, type: "text", component: Input, label: `Option ${index + 1} Label`, defaultValue: option.label })),
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: `options[${index}].group`, type: "text", component: Input, label: `Option ${index + 1} Group (optional)`, defaultValue: option.group })),
            React.createElement(Fieldset.Item, null,
                React.createElement(ButtonClean, { label: "Remove", onClick: () => handleOptionRemove(index) })))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "label", component: Input, label: "Label", placeholder: "Setting label" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "info", component: Input, label: "Info (optional)", placeholder: "Help text for this setting" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Field, { name: "default", component: Input, label: "Default Value (optional)", placeholder: "Default value" }))),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(OptionsSection, null,
                    React.createElement(OptionsTitle, null, "Options"),
                    React.createElement(OptionsDescription, null, "Add the available options for this select field. Groups are optional and can be used to organize options.")))),
        renderOptions(),
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(ButtonClean, { onClick: handleOptionAdd, label: "Add Option" })))));
};
